module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"create_review":"制作商品评论"}}')
  delete Component.options._Ctor
}
